module.exports = __webpack_public_path__ + "static/media/grin-tongue-wink.a7571947.svg";